import AdminEditableName from "./AdminActions/AdminEditableName.vue";
import AdminToolbar from "./AdminActions/AdminToolbar.vue";
import AdminFilters from "./AdminActions/AdminFilters/AdminFilters.vue";

// Registra el plugin globalmente para usarse 
// dentro de cualquier app Vue ya montada
Vue.component("admin-editable-name", AdminEditableName);
Vue.component("admin-toolbar", AdminToolbar);
Vue.component("admin-filters", AdminFilters);
